import React from 'react';
import TimeoutWarningModal from '../../timeoutWarning/components/TimeoutWarningModal';
import NewUserEmailPreferencesModal from '../../account/components/NewUserEmailPreferencesModal';
import PrivilegeNames from '../../../constants/privilegeNames';
import { userPrivileges } from '../../../apollo/cache';
import { useReactiveVar } from '@apollo/client';

const SystemWideModals = () => {
  const privileges = useReactiveVar(userPrivileges);

  if (!privileges || !privileges.length) {
    return null;
  }

  return (
    <>
      <TimeoutWarningModal />
      {!process.env.LOCAL_DEVELOPMENT_LOGIN &&
        privileges.includes(PrivilegeNames.EmailPreferences) && <NewUserEmailPreferencesModal />}
    </>
  );
};

export default SystemWideModals;
